import React, { useEffect, useRef, useState } from "react";
import { SlIcon, SlDrawer } from "@shoelace-style/shoelace/dist/react";
import closeSvg from "../../assets/images/uncheck.svg";
import API from "../../services/api";
import {
  alphabets,
  BrandsTypes,
  capitalizeFirstLetter,
  formatAmount,
  getGenerateUrl,
  handleClickhdl,
  hardInteractionTypes,
  roles,
  softInteractionTypes,
} from "../../utils/constants";
import { useNavigate } from "react-router";
import { Toast } from "../../shared/Toast";

import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import whatsappIcon from "../../assets/images/whatsappIconGreen.svg";
import salesProfile from "../../assets/images/salesProfile.png";
import phoneIcon from "../../assets/images/callIcon.svg";
import sundayIcon from "../../assets/images/sunday.svg";
import directMeetIcon from "../../assets/images/directMeetingIcon.svg";
import virtMeetIcon from "../../assets/images/virtualMeetingIcon.svg";
import emailIcon from "../../assets/images/emailIcon.svg";
import effortAnalysisIcon from "../../assets/images/effort-analysis-icon.png";
import handshakeIcons from "../../assets/images/clients-icon.svg";
import interactionTitleIcons from "../../assets/images/interactions-title-icon.svg";
import directLineIcon from "../../assets/images/direct-meeting-blue.svg";
import virtualLineIcon from "../../assets/images/virtual-meeting-violet.svg";
import callLineIcon from "../../assets/images/phone-call-orange.svg";
import whatsappLineIcon from "../../assets/images/whatsapp-green.svg";
import emailLineIcon from "../../assets/images/email-icon-maroon.svg";
import phoneIconBlue from "../../assets/images/phone-icon-blue.svg";
import searchLightIcon from "../../assets/images/search-icon-light.svg";
import closeCircleRed from "../../assets/images/close-circle-red.svg";
import backIcon from "../../assets/images/arrow_back_icon.svg";

import copySvg from "../../assets/images/copy.svg";

import closeRed from "../../assets/images/close-red.svg";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { differenceInDays } from "date-fns";
import { formatDate } from "../../utils/dateFormat";
import BrandMonthWiseInteractions from "./BrandMonthWiseInteractions";
import SalesInteractionHistory from "./SalesInteractionHistory";
import { SetComponentId } from "../../redux/counterSlice";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function EffortAnalysis(props) {
  const currentDate = new Date();
    currentDate.setDate(1);
    currentDate.setHours(0, 0, 0, 0);
  const dispatch = useDispatch();
  dispatch(SetComponentId(34));
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const stateVariables = props;
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [activeLetters, setActiveLetters] = useState([]);
  const [letter, setLetter] = useState(null);
  const [dateHeaders, setDateHeaders] = useState([]);
  let loginRole = localStorage.getItem("role");
  let encodeMainUser = localStorage.getItem("main_user");
  const [loader, setLoader] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(props.selectedMonth||currentDate);
  const [intPreDetails, setIntPreDetails] = useState({});
  const [moreData, setMoreData] = useState({});
  const [selectedList, setSelectedList] = useState(
    localStorage.getItem("selectedSalesList") && salesUsersList?.length > 1 &&
    JSON.parse(localStorage.getItem("selectedSalesList")).length
    ? salesUsersList.filter((item) =>
        JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
          item.value
        )
      )
    : salesUsersList?.length > 1 ? [] : []
  );
  
  const [salesPerson_id, setSalesPerson_id] = useState(
    +stateVariables?.salesPerson_id || +salesUsersList[0]?.value
  );
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
      salesUsersList.map((item) =>{
        return item?.label[0]?.toUpperCase()
      }
      ).sort()
    )]);
    const [searchFilter, setSearchFilter] = useState('')
  const [showUsersFilter, setShowUsersFilter] = useState( false
      // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
    )
  const [brnW2nCompData, setBrnW2nCompData] = useState({});
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  // const [salesPerson_id, setSalesPerson_id] = useState(
  //   localStorage.getItem("selectedSalesList") &&
  //     JSON.parse(localStorage.getItem("selectedSalesList")).length
  //     ? salesUsersList.filter((item) =>
  //         JSON.parse(localStorage.getItem("selectedSalesList"))?.includes(
  //           item.value
  //         )
  //       )[0]?.value
  //     : salesUsersList[0]?.value
  // );
  const [intAxis, setIntAxis] = useState(null);
  const [newsPaperData, setNewsPaperData] = useState([]);
  const [initialRender, setIntialRender] = useState(true);
  const HeaderSearch = useSelector((state) => state.Head.adssearch);
  const [showFilter, setShowFilter] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [sortType, setSortType] = useState(-1);
  let total_campaigns_count = 0,
    total_w2n_count = 0,
    total_camp_spent = 0,
    total_w2n_spent = 0,
    total_missed = 0,
    total_known = 0,
    total_unknown = 0,
    total_interactions_count = 0;
  let totalheaderIntCount = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  const [brandMonth, setBrandMonth] = useState(null);
  const [brandMonthInteractions, setBrandMonthInteractions] = useState([]);
  const [brandMonthLoader, setBrandMonthLoader] = useState(false);
  const [brandViewDetails, setbrandViewDetails] = useState(null);
  const [salesViewData, setSalesViewData] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [toolTipShow, setToolTipShow] = useState(null);
  const [hideProfile, setHideProfile] = useState(false);
  const [actBrdsCnt, setActBrdsCnt] = useState(0)
  const [actCoverage, setActCoverage] = useState(0)
  let now = new Date();
  now.setHours(0,0,0,0)
  const monthCalendarRef = useRef(null);
  const daysRefs = useRef([]);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };
  const onSlSalesChange = (selected) => {
    setSelectedList(selected || []);
    localStorage.setItem(
      "selectedSalesList",
      JSON.stringify(selected.map((item) => item.value))
    );
    setSalesPerson_id(+selected[selected.length - 1]?.value);
    document
      .getElementById(`${selected[selected.length - 1]?.value}`)
      ?.scrollIntoView({ behavior: "smooth" });
  };
  const salesTabChange = async (sales_id) => {
    setSalesPerson_id(+sales_id);
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (loginRole !== roles.salesperson) {
      navigate("/pagenotfound");
    }
  }, []);
  useEffect(() => {
    getData(salesPerson_id, selectedMonth);
    // getSalesList();
    fetchNewsPapers();
  }, []);

  useEffect(() => {
    if (!initialRender) getData(salesPerson_id, selectedMonth);
  }, [HeaderSearch, salesPerson_id, selectedMonth]);

  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getLogo = (brand) => {
    const brandLookup = newsPaperData.filter((np) => np.name === brand);
    return brandLookup?.[0]?.logo;
  };

  const getData = async (sales = salesPerson_id, month = "") => {
    try {
      setLoader(true);
      let reqObj = {
        month,
        search: HeaderSearch,
      };
      if (sales !== -1) reqObj.sales_id = sales;
      let res = await API({
        url: "/effort_analysis/get",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (res.code === 200) {
        setData(res.data.brandMonthdata);
        setDateHeaders(res.data.dateHeaders);
        setMainData(res.data.brandMonthdata);
        setActiveLetters([
          ...new Set(
            res.data.brandMonthdata.map((item) =>
              item.brand_name[0].toUpperCase()
            )
          ),
        ]);
        setActBrdsCnt(res.data.activeBrandCount || 0)
        setActCoverage(res.data.coverage || 0)
        // setSpent(res.data.spent)
      }
      setLoader(false);
      setIntialRender(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    setToolTipShow(null);
  }, [data]);

  const getInteractionDetails = async (
    date,
    dateInts,
    camp_count,
    brand_id,
    brand_name,
    lastIndex
  ) => {
    try {
      let interids = dateInts.map((item) => item.id);
      let reqObj = {
        date,
        interids,
        camp_count,
        brand_id,
      };
      if (salesPerson_id) {
        reqObj.sales_id = salesPerson_id;
      }
      let result = await API({
        url: "/effort_analysis/getInterData",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      setIntPreDetails({
        ...result.data,
        brand_id,
        date,
        brand_name,
        lastIndex,
      });
    } catch (error) {
      console.error("Error @ getInteractionDetails", error);
    }
  };

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const sortByCol = (type, order) => {
    let orderedData = data;
    if (order === 0) {
      if (type === 0) {
        orderedData = data.sort(
          (a, b) =>
            b.interactions.map((item) => item.dateInts).flat().length -
            a.interactions.map((item) => item.dateInts).flat().length
        );
      } else if (type === 1) {
        orderedData = data.sort(
          (a, b) => b.campaigns_count - a.campaigns_count
        );
      } else if (type === 2) {
        orderedData = data.sort((a, b) => b.w2n_count - a.w2n_count);
      } else if (type === 3) {
        orderedData = data.sort((a, b) => b.camp_spent - a.camp_spent);
      } else if (type === 4) {
        orderedData = data.sort((a, b) => b.w2n_spent - a.w2n_spent);
      }
      setSortType(type);
    }
    if (order === 1) {
      if (type === 0) {
        orderedData = data.sort(
          (a, b) =>
            a.interactions.map((item) => item.dateInts).flat().length -
            b.interactions.map((item) => item.dateInts).flat().length
        );
      } else if (type === 1) {
        orderedData = data.sort(
          (a, b) => a.campaigns_count - b.campaigns_count
        );
      } else if (type === 2) {
        orderedData = data.sort((a, b) => a.w2n_count - b.w2n_count);
      } else if (type === 3) {
        orderedData = data.sort((a, b) => a.camp_spent - b.camp_spent);
      } else if (type === 4) {
        orderedData = data.sort((a, b) => a.w2n_spent - b.w2n_spent);
      }
      setSortType(-1);
    }
    setData(orderedData);
  };

  const downloadDataAsExcel = async () => {
    setDownloadLoader(true);
    try {
      let res = await API({
        url: "/effort_analysis/get",
        method: "POST",
        responseType: "json",
        data: {
          month: selectedMonth,
          sales_id:
            window.innerWidth <= 767
              ? [salesPerson_id]
              : selectedList.length > 0
              ? selectedList.map((item) => item.value)
              : undefined,
          search: "",
        },
      });
      if (res.code === 200) {
        let data = res.data.brandMonthdata;
        let d_headers = res.data.dateHeaders;
        let sales_people = selectedList || [];
        if (sales_people.length === 0) {
          sales_people.push({
            label: localStorage.getItem("name"),
            value: data[0].sales_person_id,
          });
        }
        const workbook = XLSX.utils.book_new(); // Create a new workbook
        sales_people.forEach((salesPerson) => {
          const salesPersonData = data.filter(
            (item) => item.sales_person_id === salesPerson.value
          ); // Filter data for the salesperson
          const sheetData = [];
          // Headers
          let headers = [
            "Brand Name",
            ...d_headers.map((item) => `${item.date} ${item.day}`),
            "Total Interactions",
            "Campaigns Count",
            "W2N Count",
            "Camp Spent",
            "W2N Spent",
            "Missed",
            "Known",
            "Unknown",
          ];

          sheetData.push(headers);

          // Rows
          salesPersonData.forEach((item) => {
            const row = [
              item.brand_name,
              ...item.interactions.map(
                (intitem) => {
                  let hardCount = intitem.dateInts.filter(item => hardInteractionTypes.includes(item.type)).length || 0, softCount = intitem.dateInts.filter(item => softInteractionTypes.includes(item.type)).length || 0
                  return hardCount || softCount ? `${hardCount} | ${softCount}` : ""
                }
              ),
              `${item?.interactions?.map((tempItem) => tempItem.dateInts).flat().filter(item => hardInteractionTypes.includes(item.type))
                .length || 0} | ${item?.interactions?.map((tempItem) => tempItem.dateInts).flat().filter(item => softInteractionTypes.includes(item.type))
                .length || 0}`,
              item.campaigns_count,
              item.w2n_count,
              item.camp_spent,
              item.w2n_spent,
              item.missed || "-",
              item.known,
              item.unknown,
            ];
            sheetData.push(row);
          });

          // Convert to sheet and add to workbook
          const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
          let match = salesPerson.label.match(/^(.+?)\(\s*(.+?)\s*\)$/); // Match the pattern
          let SaleTitleName = "",
            SaleTitleDesg = "";
          if (match) {
            SaleTitleName = match[1];
            SaleTitleDesg = match[2];
          }
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            SaleTitleName?.slice(0, 30) || SaleTitleName
          );
        });

        // Trigger download
        const fileName = `Sales_Data_${months[selectedMonth?.getMonth()]}.xlsx`;
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "buffer",
        });
        const excelBlob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(excelBlob, fileName);
      } else {
        Toast("error", "Something went Wrong");
      }
    } catch (error) {
      console.error("Error downloading data:", error);
    } finally {
      setDownloadLoader(false);
    }
  };

  const HandleBrandMonthClick = async () => {
    try {
      setBrandMonthLoader(true);
      let result = await API({
        url: "/effort_analysis/getBrandMonthInteractions",
        method: "POST",
        responseType: "json",
        data: { ...brandMonth, selectedMonth },
      });
      if (result.code === 200) {
        setBrandMonthInteractions(result.data);
      } else {
        console.error("Error @ HandleBrandMonthClick", result?.data?.message);
      }
      setBrandMonthLoader(false);
    } catch (error) {
      console.error("Error @ HandleBrandMonthClick", error);
    }
  };
  useEffect(() => {
    if (brandMonth) {
      HandleBrandMonthClick(brandMonth);
    }
  }, [brandMonth]);

  const handleViewBrandHistory = async (brand) => {
    setbrandViewDetails({
      brand_id: brand.brand_id,
      sales_person_id: brand.sales_person_id,
      sales_name: salesUsersList.find((item) => item.value === +salesPerson_id)
        ?.label,
      brandsList: data.map((item) => {
        return {
          label: item.brand_name,
          value: item.brand_id,
          logo_url: item.logo_url,
        };
      }),
      year: new Date(
        new Date(selectedMonth).getFullYear(),
        0,
        1,
        0,
        0,
        0,
        0
      ).getTime(),
    });
  };
  const handleViewSalesHistory = async () => {
    setSalesViewData({
      sales_person_id: salesPerson_id,
      sales_name: salesUsersList.find((item) => item.value === +salesPerson_id)
        ?.label,
      sales_list: salesUsersList?.length ? salesUsersList : [],
    });
  };

  useEffect(() => {
    // synchronized horizontal scrolling between month calendar and days list
    const monthCalendar = document.getElementById("monthCalendar");
    const daysLists = document.querySelectorAll(".days");

    function syncScroll(source, targets) {
      targets.forEach((target) => {
        target.scrollLeft = source.scrollLeft;
      });
    }

    monthCalendar?.addEventListener("scroll", () => {
      syncScroll(monthCalendar, daysLists);
    });

    daysLists?.forEach((daysList) => {
      daysList.addEventListener("scroll", () => {
        syncScroll(daysList, daysLists);
        monthCalendar.scrollLeft = daysList.scrollLeft;
      });
    });
  }, [data]);
  const filterByLetter = (letter) => {
    if (letter && activeLetters.includes(letter)) {
      setData(
        mainData.filter((item) => item.brand_name[0].toUpperCase() === letter)
      );
      setLetter(letter);
    } else if (!letter) {
      setData(mainData);
      setLetter(letter);
    }
  };
  let salesTitleNameDesg =
    salesUsersList.find((item) => item.value === salesPerson_id)?.label ||
    localStorage.getItem("name");
  let match = salesTitleNameDesg.match(/^(.+?)\(\s*(.+?)\s*\)$/); // Match the pattern
  let SaleTitleName = "",
    SaleTitleDesg = "";
  if (match) {
    SaleTitleName = match[1];
    SaleTitleDesg = match[2];
  }

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const getBrandW2nSpent = async(brand_id, sales_person_id, brand_name) => {
    try {
      let reqObj = {
        selectedMonth,
        brand_id, sales_person_id
      };
      let res = await API({
        url: "/effort_analysis/getBrnW2nCompData",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (res.code === 200) {
        setBrnW2nCompData({brand_name, data: res.data || []});
      }
      else{
      }
      
    } catch (error) {
      console.error("Error @ getBrandW2nSpent", error)
    }
  }

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const closeUsersFilter = () => {
    try {
      if (selectedList.length === 0) { Toast("error", "Select Atleast a User") }
      else { setSalesPerson_id(selectedList[0].value); setShowUsersFilter(false) }
    } catch (error) {
      console.error("Error @ closeUsersFilter", error)
    }
  }

  return (
    <div class="effort-analyis">
      <div
        class={`effortbHeader noBg ${fullScreen ? "afterToggle" : ""} ${
          brandMonth ? "changeIndex" : ""
        }`}
      >
        <div class="titleRow">
          <div class="pageTitle">
            {salesUsersList?.length > 1 ? (
              <button
                class="goBack-btn"
                onClick={() => props.setShowEffort(false)}
              >
                <img src={backIcon} alt="" /> <span>Go To Dashboard</span>
              </button>
            ) : null}
            <h3>
              <i class="icon">
                <img src={effortAnalysisIcon} alt="" />
              </i>{" "}
              <span>Effort Analysis</span>
            </h3>
            <div class="view-navigate mobileOnly">
              <DatePicker
                selected={selectedMonth}
                onChange={handleMonthChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                className="dateChooser"
              />
            </div>
          </div>
          <div class="filters-more">
            {downloadLoader ? (
              <TableLoader />
            ) : (
              <div
                className="d-flex items-center justify-center bg-slate-200 rounded w-8 h-8"
                onClick={() =>
                  downloadDataAsExcel(selectedMonth.getMonth() + 1)
                }
              >
                <sl-tooltip content="Download">
                  <SlIcon
                    library="lucide"
                    name="download"
                    className="hover:cursor-pointer hover:text-sky-400 transition-all ease-in-out"
                  ></SlIcon>
                </sl-tooltip>
              </div>
            )}

            {/* {salesUsersList.length !== 1 ? (
              <select
                name="executive"
                id="effort-executive"
                placeholder="Select"
                value={salesPerson_id}
                onChange={(e) => {
                  if (e.target.value === -1) return;
                  if (window.innerWidth <= 767) {
                    setSalesPerson_id(+e.target.value);
                    setSelectedList([
                      salesUsersList.find(
                        (item) => item?.value === +e?.target?.value
                      ),
                    ]);
                    localStorage.setItem(
                      "selectedSalesList",
                      JSON.stringify([+e.target.value])
                    );
                  } else {
                    onSlSalesChange([
                      ...selectedList,
                      salesUsersList.find(
                        (item) => item?.value === +e?.target?.value
                      ),
                    ]);
                  }
                }}
              >
                {window.innerWidth <= 767 ? (
                  salesUsersList.map((item) => (
                    <option value={item.value}>{item.label}</option>
                  ))
                ) : (
                  <>
                    <option value={-1}>Select Sales</option>
                    {salesUsersList
                      .filter(
                        (item) =>
                          !selectedList
                            .map((item) => item.value)
                            .includes(item.value)
                      )
                      .map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                  </>
                )}
              </select>
            ) : null} */}
            {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
          </div>
        </div>
      </div>

      {/* <!-- Effort Analysis - Calendar View --> */}
      <div class="view-container">
        <div class="viewHeader">
          {/* <button class="calendar"><img src="assets/images/calendar.svg" alt="" /> <span>Oct,
                            2024</span></button> */}
          <div class="view-navigate desktopOnly">
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser"
            />
          </div>
          <div className="selected-users">
            {selectedList.map((item) => {
              return (
                <button
                  class={`header-btn ${
                    salesPerson_id === item.value ? " active" : ""
                  }`}
                  onClick={() => {
                    salesTabChange(item.value);
                  }}
                >
                  {capitalizeFirstLetter(item.label)}
                  {salesUsersList.length !== 1 ? (
                    <span
                      class="close"
                      onClick={(e) => {
                        e.stopPropagation();
                        let nextList = selectedList.filter(
                          (sitem) => sitem.value !== item.value
                        );
                        setSelectedList(nextList);
                        setSalesPerson_id(+nextList[0]?.value);
                        localStorage.setItem(
                          "selectedSalesList",
                          JSON.stringify(nextList.map((item) => item.value))
                        );
                      }}
                    >
                      <img src={closeRed} alt="" />
                    </span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </div>
        <div class="viewBody">
          {dateHeaders.length ? (
            <div class="calendar-header">
              <h6>Client / Brand</h6>
              <ul
                class="monthCalendar"
                id="monthCalendar"
                ref={monthCalendarRef}
              >
                {dateHeaders?.map((item, index) => {
                  return (
                    <li
                      class={
                        item.day === "Sun"
                          ? "sun"
                          : item.day === "Sat"
                          ? "sat"
                          : ""
                      }
                    >
                      <button>
                        <span>{item.day[0]}</span> {item.date}
                      </button>
                    </li>
                  );
                })}
              </ul>
              <button
                id="changeView"
                class="mobileOnly"
                onClick={() => {
                  setFullScreen(!fullScreen);
                }}
              >
                {!fullScreen ? "Full Screen View" : "Exit Full Screen View"}
              </button>
            </div>
          ) : null}
          <div class="clientList">
            {data?.length && !loader ? (
              <>
                {data?.map((item, index) => {
                  let InteractionsCount = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
                  let brand_camp_targets = [
                    ...new Set(
                      item.interactions
                        .map((dateItem) => dateItem.camp_targets)
                        .flat()
                    ),
                  ];
                  item.interactions
                    .map((dateItem) => dateItem.dateInts)
                    .flat()
                    .map((tempItem) => {
                      if (!InteractionsCount[tempItem.type]) {
                        InteractionsCount[tempItem.type] = 1;
                      } else {
                        InteractionsCount[tempItem.type] += 1;
                      }
                      if (!totalheaderIntCount[tempItem.type]) {
                        totalheaderIntCount[tempItem.type] = 1;
                      } else {
                        totalheaderIntCount[tempItem.type] += 1;
                      }
                    });
                  total_campaigns_count =
                    +total_campaigns_count + +item.campaigns_count;
                  total_w2n_count = +total_w2n_count + +item.w2n_count;
                  total_camp_spent = +total_camp_spent + +item.camp_spent;
                  total_w2n_spent = +total_w2n_spent + +item.w2n_spent;
                  total_missed = +total_missed + +(item.missed || 0);
                  total_known = +total_known + +item.known;
                  total_unknown = +total_unknown + +item.unknown;
                  total_interactions_count =
                    +total_interactions_count +
                    +(
                      item?.interactions
                        ?.map((tempItem) => tempItem.dateInts.filter(item => hardInteractionTypes.includes(item.type)))
                        .flat().length || 0
                    );
                  return (
                    <>
                      <div class="clientDetails">
                        <div class="mainRow">
                          <div class="brand_name" title={item.brand_name}>
                            <span>{`#${index + 1}`}</span>
                            <h1 onClick={(e) => {e.stopPropagation(); getBrandW2nSpent(item.brand_id, item.sales_person_id,item.brand_name)}}>{capitalizeFirstLetter(item.brand_name)}</h1>
                          </div>
                          <ul
                            class="days"
                            id="daysList"
                            ref={(el) => (daysRefs.current[index] = el)}
                          >
                            {item?.interactions?.map((dateItem, dateIndex) => {
                              let {
                                camp_targets,
                                dateInts,
                                camp_count,
                                day,
                                unknown,
                                known,
                                w2n_count,
                              } = dateItem;
                              let isEmpty = camp_targets?.length
                                ? 0
                                : dateInts?.length
                                ? 0
                                : w2n_count
                                ? 0
                                : 1;
                              let isMore =
                                camp_targets?.length +
                                dateInts?.length +
                                (w2n_count ? 1 : 0);
                              return (
                                <li
                                  className={`${
                                    day === 6 ? "sat" : day === 0 ? "sun" : ""
                                  } ${isMore > 2 ? "tip-parent" : ""}`}
                                  onClick={() => {
                                    if (window.innerWidth <= 767) {
                                      if (
                                        toolTipShow?.brand_id ===
                                          item.brand_id &&
                                        toolTipShow.dateIndex === dateIndex
                                      ) {
                                        setToolTipShow(null);
                                      } else {
                                        setToolTipShow({
                                          brand_id: item.brand_id,
                                          dateIndex,
                                        });
                                      }
                                    }
                                  }}
                                >
                                  <button
                                    class={
                                      isEmpty
                                        ? "empty"
                                        : `combined-ad ${
                                            isMore > 2 ? "more-ads" : ""
                                          }`
                                    }
                                  >
                                    {isMore > 2 ? (
                                      isMore
                                    ) : !isEmpty ? (
                                      <>
                                        {camp_targets.map((item) => (
                                          <img
                                            src={
                                              newsPaperData.find(
                                                (nitem) => nitem.name === item
                                              )?.logo
                                            }
                                            alt=""
                                          />
                                        ))}
                                        {w2n_count ? (
                                          <img
                                            src={
                                              newsPaperData.find(
                                                (item) =>
                                                  item.name === "Way2news"
                                              )?.logo
                                            }
                                          />
                                        ) : null}
                                        {dateInts.map((item) => (
                                          <img
                                            src={
                                              item.type === 1
                                                ? directMeetIcon
                                                : item.type === 2
                                                ? virtMeetIcon
                                                : item.type === 3
                                                ? phoneIcon
                                                : item.type === 4
                                                ? whatsappIcon
                                                : item.type === 5
                                                ? emailIcon
                                                : ""
                                            }
                                            alt=""
                                          />
                                        ))}
                                      </>
                                    ) : (
                                      <img src={sundayIcon} />
                                    )}
                                  </button>
                                  {isMore > 2 ? (
                                    <div
                                      class={`tooltip ${
                                        toolTipShow?.brand_id ===
                                          item.brand_id &&
                                        toolTipShow.dateIndex === dateIndex
                                          ? "show"
                                          : ""
                                      }`}
                                    >
                                      <div class="img-stack-list">
                                        {camp_targets?.length || w2n_count ? (
                                          <div className="newspaper">
                                            <h6>Newspapers:</h6>
                                            <div className="asRow">
                                              {camp_targets.map((item) => (
                                                <img
                                                  src={
                                                    newsPaperData.find(
                                                      (nitem) =>
                                                        nitem.name === item
                                                    )?.logo
                                                  }
                                                  alt=""
                                                />
                                              ))}
                                            </div>
                                            {w2n_count ? (
                                              <img
                                                src={
                                                  newsPaperData.find(
                                                    (item) =>
                                                      item.name === "Way2news"
                                                  )?.logo
                                                }
                                              />
                                            ) : null}
                                          </div>
                                        ) : null}
                                        {dateInts?.length ? (
                                          <div className="interaction">
                                            <h6>Interactions:</h6>
                                            <div className="asRow">
                                              {dateInts.map((item) => (
                                                <img
                                                  src={
                                                    item.type === 1
                                                      ? directMeetIcon
                                                      : item.type === 2
                                                      ? virtMeetIcon
                                                      : item.type === 3
                                                      ? phoneIcon
                                                      : item.type === 4
                                                      ? whatsappIcon
                                                      : item.type === 5
                                                      ? emailIcon
                                                      : ""
                                                  }
                                                  alt=""
                                                />
                                              ))}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  ) : null}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div
                          class="interactionStats"
                          onClick={() => {
                            if (
                              !brandMonth ||
                              brandMonth.brand_id !== item.brand_id
                            )
                              setBrandMonth({
                                brand_id: item.brand_id,
                                sales_person_id: item.sales_person_id,
                              });
                            else setBrandMonth(null);
                          }}
                        >
                          <div class="count">
                            <h6>Total Interactions</h6>
                            <h3>
                              {item?.interactions
                                ?.map((tempItem) => tempItem.dateInts.filter(item => hardInteractionTypes.includes(item.type)))
                                .flat().length || 0}
                            </h3>
                            <ul class="recentActivity">
                              <li class="direct-meeting">
                                <i class="icon">
                                  {" "}
                                  <span>{InteractionsCount[1]}</span>
                                </i>
                              </li>
                              <li class="virtual-meeting">
                                <i class="icon">
                                  <span>{InteractionsCount[2]}</span>
                                </i>
                              </li>
                              <li class="phone-call">
                                <i class="icon">
                                  <span>{InteractionsCount[3]}</span>
                                </i>
                              </li>
                              <li class="whatsapp-chat">
                                <i class="icon">
                                  <span>{InteractionsCount[4]}</span>
                                </i>
                              </li>
                              <li class="email-chat">
                                <i class="icon">
                                  <span>{InteractionsCount[5]}</span>
                                </i>
                              </li>
                            </ul>
                          </div>
                          <div class="stats">
                            <h6>Competitor Campaigns</h6>
                            <h3>{item.campaigns_count}</h3>
                            <span class="list">
                              <dd class="combined-ad">
                                {brand_camp_targets.map((item) => (
                                  <img
                                    src={
                                      newsPaperData.find(
                                        (nitem) => nitem.name === item
                                      )?.logo
                                    }
                                    alt=""
                                  />
                                ))}
                              </dd>
                            </span>
                          </div>
                          <div class="stats">
                            <h6>W2N Campaigns</h6>
                            <h3>{item.w2n_count}</h3>
                            <span class="list">
                              {item.w2n_count ? (
                                <img
                                  src={
                                    newsPaperData.find(
                                      (item) => item.name === "Way2news"
                                    )?.logo
                                  }
                                />
                              ) : null}
                            </span>
                          </div>
                          <div class="stats" onClick={(e) => {e.stopPropagation(); getBrandW2nSpent(item.brand_id, item.sales_person_id,item.brand_name)}}>
                            <h6>Competitor Spent</h6>
                            <h2 class="competetor-spent">
                              {formatAmount(item.camp_spent) || 0}
                            </h2>
                          </div>
                          <div class="stats" onClick={(e) => {e.stopPropagation(); getBrandW2nSpent(item.brand_id, item.sales_person_id,item.brand_name)}}>
                            <h6>W2N Spent</h6>
                            <h2 class="w2n-spent">
                              {formatAmount(item.w2n_spent) || 0}
                            </h2>
                          </div>
                          <div class="stats">
                            <h6>Missed</h6>
                            <h2>{item.missed || "-"}</h2>
                          </div>
                          <div class="stats">
                            <h6>Known</h6>
                            <h2>{item.known || 0}</h2>
                          </div>
                          <div class="stats">
                            <h6>Unknown</h6>
                            <h2>{item.unknown || 0}</h2>
                          </div>
                        </div>
                      </div>
                      <div
                        id="toggleContent"
                        className={
                          brandMonth &&
                          brandMonth.brand_id === item.brand_id &&
                          brandMonth.sales_person_id === item.sales_person_id
                            ? "show"
                            : ""
                        }
                      >
                        <h1 class="mobileOnly modal-heading">
                          {item.brand_name}
                          <span
                            id="close-modal"
                            onClick={() => {
                              if (
                                !brandMonth ||
                                brandMonth.brand_id !== item.brand_id
                              )
                                setBrandMonth({
                                  brand_id: item.brand_id,
                                  sales_person_id: item.sales_person_id,
                                });
                              else setBrandMonth(null);
                            }}
                          >
                            <img src={closeCircleRed} alt="" />
                          </span>
                        </h1>
                        <div class="stack-inline">
                          <h4>
                            Interaction History:{" "}
                            <span>{brandMonthInteractions?.length || 0}</span>
                          </h4>
                          <button
                            class="history-btn"
                            onClick={() => handleViewBrandHistory(item)}
                          >
                            <img src={searchLightIcon} alt="" />
                            <span>View Full History</span>
                          </button>
                        </div>
                        {brandMonthInteractions?.length && !brandMonthLoader ? (
                          <div class="interactionHistory">
                            {brandMonthInteractions.map((item) => {
                              let mobileNumbers = [],
                                emails = [];
                              if (item.mobile1)
                                mobileNumbers.push(item.mobile1);
                              if (item.mobile2)
                                mobileNumbers.push(item.mobile2);
                              if (item.email1) emails.push(item.email1);
                              if (item.email2) emails.push(item.email2);
                              let itemDate = new Date(item.date * 1000)
                              itemDate.setHours(0,0,0,0)

                              return (
                                <div class="interaction">
                                  <div class="int-head">
                                    <div class="name">
                                      <img src={interactionTitleIcons} alt="" />
                                      <h1>
                                        {capitalizeFirstLetter(item.name)}{" "}
                                        <span>
                                          {capitalizeFirstLetter(
                                            item.designation
                                          )}
                                        </span>
                                      </h1>
                                    </div>
                                    <div
                                      class={`meet-type ${
                                        item.type === 1
                                          ? "direct-meeting"
                                          : item.type === 2
                                          ? "virtual-meeting"
                                          : item.type === 3
                                          ? "phone-call"
                                          : item.type === 4
                                          ? "whatsapp-chat"
                                          : item.type === 5
                                          ? "email-chat"
                                          : ""
                                      }`}
                                    >
                                      <img
                                        src={
                                          item.type === 1
                                            ? directLineIcon
                                            : item.type === 2
                                            ? virtualLineIcon
                                            : item.type === 3
                                            ? callLineIcon
                                            : item.type === 4
                                            ? whatsappLineIcon
                                            : item.type === 5
                                            ? emailLineIcon
                                            : ""
                                        }
                                        alt=""
                                      />
                                      <p>
                                        {item.type === 1
                                          ? "Direct Meeting"
                                          : item.type === 2
                                          ? "Virtual Meeting"
                                          : item.type === 3
                                          ? "Phone Call"
                                          : item.type === 4
                                          ? "WhatsApp"
                                          : item.type === 5
                                          ? "Email"
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                  <div class="int-body">
                                    <p>{item.description}</p>
                                  </div>
                                  <div class="int-footer">
                                    <div className="d-flex flex-col gap-1">
                                      <h5>
                                        <img src={phoneIconBlue} alt="" />{" "}
                                        <span>{mobileNumbers[0]}</span>
                                        <img
                                          src={copySvg}
                                          alt=""
                                          onClick={() =>
                                            handleClickhdl(mobileNumbers[0])
                                          }
                                        />
                                      </h5>
                                      {/* <h5>
                                        <img src={emailLineIcon} alt="" />{" "}
                                        <span>{emails[0]}</span>
                                        <img src={copySvg} alt="" />
                                      </h5> */}
                                    </div>

                                    <h6>{`${differenceInDays(
                                      now,
                                      itemDate
                                    )} days ago | On ${formatDate(
                                      item.date
                                    )}`}</h6>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : !brandMonthInteractions?.length &&
                          !brandMonthLoader ? (
                          <div className="noData">
                            <h4>No Interactions found</h4>
                          </div>
                        ) : (
                          <div className="w-full h-full d-flex justify-center">
                            <TableLoader />
                          </div>
                        )}
                      </div>
                    </>
                  );
                })}
              </>
            ) : !data?.length && !loader ? (
              <div className="w-full h-full d-flex justify-center">
                <NoDataFound />
              </div>
            ) : (
              <div className="w-full h-full d-flex justify-center">
                <TableLoader />
              </div>
            )}
          </div>
        </div>
        <div
          class={`viewFooter ${fullScreen ? "toggleHeight" : ""}`}
          id="executiveProfile"
        >
          {/* <button
            className="hideProfile"
            onClick={() => setHideProfile(!hideProfile)}
          ><span>Toggle Profile</span></button> */}
          <ul class="client-navigator">
            <li
              onClick={() => filterByLetter(null)}
              className={`${letter === null ? "active" : ""} available`}
            >
              All
            </li>
            <li
              onClick={() => filterByLetter("A")}
              className={`${letter === "A" ? "active" : ""} ${
                activeLetters.includes("A") ? "available" : ""
              }`}
            >
              A
            </li>
            <li
              onClick={() => filterByLetter("B")}
              className={`${letter === "B" ? "active" : ""} ${
                activeLetters.includes("B") ? "available" : ""
              }`}
            >
              B
            </li>
            <li
              onClick={() => filterByLetter("C")}
              className={`${letter === "C" ? "active" : ""} ${
                activeLetters.includes("C") ? "available" : ""
              }`}
            >
              C
            </li>
            <li
              onClick={() => filterByLetter("D")}
              className={`${letter === "D" ? "active" : ""} ${
                activeLetters.includes("D") ? "available" : ""
              }`}
            >
              D
            </li>
            <li
              onClick={() => filterByLetter("E")}
              className={`${letter === "E" ? "active" : ""} ${
                activeLetters.includes("E") ? "available" : ""
              }`}
            >
              E
            </li>
            <li
              onClick={() => filterByLetter("F")}
              className={`${letter === "F" ? "active" : ""} ${
                activeLetters.includes("F") ? "available" : ""
              }`}
            >
              F
            </li>
            <li
              onClick={() => filterByLetter("G")}
              className={`${letter === "G" ? "active" : ""} ${
                activeLetters.includes("G") ? "available" : ""
              }`}
            >
              G
            </li>
            <li
              onClick={() => filterByLetter("H")}
              className={`${letter === "H" ? "active" : ""} ${
                activeLetters.includes("H") ? "available" : ""
              }`}
            >
              H
            </li>
            <li
              onClick={() => filterByLetter("I")}
              className={`${letter === "I" ? "active" : ""} ${
                activeLetters.includes("I") ? "available" : ""
              }`}
            >
              I
            </li>
            <li
              onClick={() => filterByLetter("J")}
              className={`${letter === "J" ? "active" : ""} ${
                activeLetters.includes("J") ? "available" : ""
              }`}
            >
              J
            </li>
            <li
              onClick={() => filterByLetter("K")}
              className={`${letter === "K" ? "active" : ""} ${
                activeLetters.includes("K") ? "available" : ""
              }`}
            >
              K
            </li>
            <li
              onClick={() => filterByLetter("L")}
              className={`${letter === "L" ? "active" : ""} ${
                activeLetters.includes("L") ? "available" : ""
              }`}
            >
              L
            </li>
            <li
              onClick={() => filterByLetter("M")}
              className={`${letter === "M" ? "active" : ""} ${
                activeLetters.includes("M") ? "available" : ""
              }`}
            >
              M
            </li>
            <li
              onClick={() => filterByLetter("N")}
              className={`${letter === "N" ? "active" : ""} ${
                activeLetters.includes("N") ? "available" : ""
              }`}
            >
              N
            </li>
            <li
              onClick={() => filterByLetter("O")}
              className={`${letter === "O" ? "active" : ""} ${
                activeLetters.includes("O") ? "available" : ""
              }`}
            >
              O
            </li>
            <li
              onClick={() => filterByLetter("P")}
              className={`${letter === "P" ? "active" : ""} ${
                activeLetters.includes("P") ? "available" : ""
              }`}
            >
              P
            </li>
            <li
              onClick={() => filterByLetter("Q")}
              className={`${letter === "Q" ? "active" : ""} ${
                activeLetters.includes("Q") ? "available" : ""
              }`}
            >
              Q
            </li>
            <li
              onClick={() => filterByLetter("R")}
              className={`${letter === "R" ? "active" : ""} ${
                activeLetters.includes("R") ? "available" : ""
              }`}
            >
              R
            </li>
            <li
              onClick={() => filterByLetter("S")}
              className={`${letter === "S" ? "active" : ""} ${
                activeLetters.includes("S") ? "available" : ""
              }`}
            >
              S
            </li>
            <li
              onClick={() => filterByLetter("T")}
              className={`${letter === "T" ? "active" : ""} ${
                activeLetters.includes("T") ? "available" : ""
              }`}
            >
              T
            </li>
            <li
              onClick={() => filterByLetter("U")}
              className={`${letter === "U" ? "active" : ""} ${
                activeLetters.includes("U") ? "available" : ""
              }`}
            >
              U
            </li>
            <li
              onClick={() => filterByLetter("V")}
              className={`${letter === "V" ? "active" : ""} ${
                activeLetters.includes("V") ? "available" : ""
              }`}
            >
              V
            </li>
            <li
              onClick={() => filterByLetter("W")}
              className={`${letter === "W" ? "active" : ""} ${
                activeLetters.includes("W") ? "available" : ""
              }`}
            >
              W
            </li>
            <li
              onClick={() => filterByLetter("X")}
              className={`${letter === "X" ? "active" : ""} ${
                activeLetters.includes("X") ? "available" : ""
              }`}
            >
              X
            </li>
            <li
              onClick={() => filterByLetter("Y")}
              className={`${letter === "Y" ? "active" : ""} ${
                activeLetters.includes("Y") ? "available" : ""
              }`}
            >
              Y
            </li>
            <li
              onClick={() => filterByLetter("Z")}
              className={`${letter === "Z" ? "active" : ""} ${
                activeLetters.includes("Z") ? "available" : ""
              }`}
            >
              Z
            </li>
          </ul>
          <div class="execProfile">
            <div class="profile-pic">
              <img src={salesProfile} alt="" />
            </div>
            <div class="profile-details">
              <h1>
                <div className="d-flex flex-col">
                  <p className="m-0">{capitalizeFirstLetter(SaleTitleName)}</p>
                  <span>{SaleTitleDesg}</span>
                  <ul class="recentActivity">
                    <li class="direct-meeting">
                      <i class="icon">
                        {" "}
                        <span>{totalheaderIntCount[1]}</span>
                      </i>
                    </li>
                    <li class="virtual-meeting">
                      <i class="icon">
                        <span>{totalheaderIntCount[2]}</span>
                      </i>
                    </li>
                    <li class="phone-call">
                      <i class="icon">
                        <span>{totalheaderIntCount[3]}</span>
                      </i>
                    </li>
                    <li class="whatsapp-chat">
                      <i class="icon">
                        <span>{totalheaderIntCount[4]}</span>
                      </i>
                    </li>
                    <li class="email-chat">
                      <i class="icon">
                        <span>{totalheaderIntCount[5]}</span>
                      </i>
                    </li>
                  </ul>
                </div>
                <div className="highlights">
                <i class="clients">
                  {total_interactions_count}
                  <sup>+</sup>
                </i>
                <i className="brndscnt" title={'Active Brands'}>
                  {actBrdsCnt}
                </i>
                <i className="coverage" title={'Coverage'}>
                  {actCoverage.toFixed(2)}
                </i>
                </div>
              </h1>
              <div class="designation">
                {/* <p class="level">National Sales Head</p> */}
                {/* <p class="location">Hyderabad</p> */}
              </div>
            </div>
          </div>
          <div class="stats">
            <h2>{total_campaigns_count}</h2>
            <h6>Competitor Campaigns</h6>
          </div>
          <div class="stats">
            <h2>{total_w2n_count}</h2>
            <h6>W2N Campaigns</h6>
          </div>
          <div class="stats">
            <h2 class="competetor-spent">{formatAmount(total_camp_spent)}</h2>
            <h6>Competitor Spent</h6>
          </div>
          <div class="stats">
            <h2 class="w2n-spent">{formatAmount(total_w2n_spent)}</h2>
            <h6>W2N Spent</h6>
          </div>
          <div class="stats">
            <h2>{total_missed}</h2>
            <h6>Missed</h6>
          </div>
          <div class="stats">
            <h2>{total_known}</h2>
            <h6>Known</h6>
          </div>
          <div class="stats">
            <div className="percent">
            <h2>{total_unknown}</h2>
            <h5>{((total_unknown/(total_unknown + total_known) * 100) || 0).toFixed(1) }%</h5>
            </div>
            <h6>Unknown</h6>
          </div>
          <button
            class="history-btn"
            onClick={() => {
              handleViewSalesHistory();
            }}
          >
            <img src={handshakeIcons} alt="" />
            <span>Show Interactions History</span>
          </button>
        </div>
      </div>
      {brandViewDetails ? (
        <BrandMonthWiseInteractions
          details={brandViewDetails}
          setShow={setbrandViewDetails}
          setShowEffort={props.setShowEffort}
        />
      ) : null}
      {salesViewData ? (
        <SalesInteractionHistory
          details={salesViewData}
          setShow={setSalesViewData}
          setShowEffort={props.setShowEffort}
          selectedMonth={selectedMonth}
        />
      ) : null}

      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => closeUsersFilter()}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => closeUsersFilter()}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => closeUsersFilter()}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
      <SlDrawer
        label={brnW2nCompData.brand_name}
        open={Object.keys(brnW2nCompData).length}
        onSlRequestClose={() => {
          setBrnW2nCompData({})
        }}
        placement="bottom"
        // noHeader
        onSlAfterHide={() => { setBrnW2nCompData({}) }}
      // style={{ "--size": "fit-content" }}
      >
        <table className="table brnW2nCompTable">
          <thead>
            <tr>
              <th>Date</th>
              <th>Competitors</th>
              <th>Way2News</th>
              <th>Competitor Spent</th>
              <th>W2N Spent</th>
              <th>Known</th>
              <th>Unknown</th>
              <th>Missed</th>
            </tr>
          </thead>
          {brnW2nCompData?.data?.length && !loader ? (
            <>
              <tbody>{
                brnW2nCompData?.data?.map(item => <tr>
                  <td>{formatDate(item.date)}</td>
                  <td>{
                    <div class="combined-ad d-flex no-wrap">
                      {item.camp_targets.map((item) => (
                        <img
                          src={
                            newsPaperData.find(
                              (nitem) => nitem.name === item
                            )?.logo
                          }
                          alt=""
                        />
                      ))}
                    </div>}
                  </td>
                  <td className={item.w2n_count ? 'green' : 'red'}>{item.w2n_count ? 'YES' : 'NO'}</td>
                  <td className="red" title={item.campaigns_spent}>{formatAmount(item.campaigns_spent) || '-'}</td>
                  <td className="green" title={item.w2n_spent}>{formatAmount(item.w2n_spent) || '-'}</td>
                  <td className="green" title={item.known}>{item.known || '-'}</td>
                  <td className="red" title={item.unknown}>{item.unknown || '-'}</td>
                  <td className="red" title={item.missed}>{item.missed || '-'}</td>
                </tr>)
              }</tbody>
            </>
          ) : !brnW2nCompData?.data?.length && !loader ? (

            <NoDataFound colspan={99} />
          ) : (
            <TableLoader colspan={99} />
          )}
        </table>
      </SlDrawer>
    </div>
  );
}
export default EffortAnalysis;
